import { render } from "./ActivityCreate.vue?vue&type=template&id=7de1c23f&scoped=true"
const script = {}

import "./ActivityCreate.vue?vue&type=style&index=0&id=7de1c23f&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7de1c23f"]])

export default __exports__